module.exports = __webpack_public_path__ + "img/3E2335_D36A1B_8E4A2E_2842A5-256px.0640b688.png";